import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Radar, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center neon-border rounded-lg">
                <Radar className="w-4 h-4 text-[#00F0FF]" />
              </div>
              <span className="font-['Outfit'] text-base font-semibold text-white">
                Project Radar <span className="neon-text">AR</span>
              </span>
            </div>
            <p className="text-xs text-[#A0A0B0] leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          {/* Links */}
          <div>
            <span className="text-[10px] font-['JetBrains_Mono'] text-[#606070] tracking-[0.2em] uppercase block mb-4">
              {t.footer.nav_label}
            </span>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-[#A0A0B0] hover:text-[#00F0FF] transition-colors"
                >
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard"
                  className="text-sm text-[#A0A0B0] hover:text-[#00F0FF] transition-colors"
                >
                  {t.nav.dashboard}
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-contact-link"
                  to="/contact"
                  className="text-sm text-[#A0A0B0] hover:text-[#00F0FF] transition-colors"
                >
                  {t.nav.contact}
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-nav-terms-link"
                  to="/terms"
                  className="text-sm text-[#A0A0B0] hover:text-[#00F0FF] transition-colors"
                >
                  {t.footer.terms}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <span className="text-[10px] font-['JetBrains_Mono'] text-[#606070] tracking-[0.2em] uppercase block mb-4">
              {t.footer.operator}
            </span>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-start gap-2 text-[#A0A0B0]">
                <MapPin className="w-3.5 h-3.5 text-[#00F0FF] mt-0.5 flex-shrink-0" />
                <span>Reto Ramstein · Postfach 590 · 3000 Bern 14 · CH</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 text-[#00F0FF] flex-shrink-0" />
                <a
                  href="mailto:ramsteinreto@gmail.com"
                  className="text-[#A0A0B0] hover:text-[#00F0FF] transition-colors font-['JetBrains_Mono'] text-[12px]"
                >
                  ramsteinreto@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 text-[#00F0FF] flex-shrink-0" />
                <a
                  href="tel:+41794639178"
                  className="text-[#A0A0B0] hover:text-[#00F0FF] transition-colors font-['JetBrains_Mono'] text-[12px]"
                >
                  +41 79 463 91 78
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <span className="text-[11px] text-[#606070] font-['JetBrains_Mono']">
            © {year} Project Radar AR · Reto Ramstein
          </span>
          <div className="flex items-center gap-4">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-[11px] text-[#606070] hover:text-[#00F0FF] transition-colors font-['JetBrains_Mono']"
            >
              {t.footer.terms}
            </Link>
            <Link
              to="/contact"
              className="text-[11px] text-[#606070] hover:text-[#00F0FF] transition-colors font-['JetBrains_Mono']"
            >
              {t.footer.imprint}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
